(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fm-categories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fm-categories')) {
  class FmCategories extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.pa-category-grid');
      this.stage = this.querySelector('[data-cat-stage]');
      this.currentId = null;
      if (!this.grid || !this.stage) return;

      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);

      this.sync();
      // Theme editor re-renders blocks: keep the products area in step with the cards
      this.observer = new MutationObserver(() => this.sync());
      this.watch();

      if (this.dataset.openFirst === 'true') {
        const first = this.querySelector('[data-cat-card]');
        if (first) this.open(first);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.observer) this.observer.disconnect();
    }

    watch() { if (this.observer) this.observer.observe(this.grid, { childList: true, subtree: true }); }

    // Move every category's products panel into the full-width area under the grid
    sync() {
      if (this.observer) this.observer.disconnect();

      this.grid.querySelectorAll('[data-cat-panel]').forEach((panel) => {
        const old = [...this.stage.querySelectorAll('[data-cat-panel]')].find((p) => p.id === panel.id);
        if (old) old.remove();
        panel.inert = true;
        this.stage.appendChild(panel);
      });

      // Drop panels whose category card was removed
      const ids = new Set([...this.querySelectorAll('[data-cat-card]')].map((c) => c.getAttribute('aria-controls')));
      this.stage.querySelectorAll('[data-cat-panel]').forEach((p) => { if (!ids.has(p.id)) p.remove(); });

      // Re-apply the open category (e.g. after the editor re-rendered a block)
      if (this.currentId) {
        const card = [...this.querySelectorAll('[data-cat-card]')].find((c) => c.getAttribute('aria-controls') === this.currentId);
        if (card) this.open(card); else this.currentId = null;
      }

      this.watch();
    }

    // Show the products of the chosen category, hide all the others
    open(card) {
      const id = card.getAttribute('aria-controls');
      this.currentId = id;
      this.querySelectorAll('[data-cat-card]').forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-expanded', String(on));
      });
      this.stage.querySelectorAll('[data-cat-panel]').forEach((p) => {
        const on = p.id === id;
        p.classList.toggle('is-open', on);
        p.setAttribute('aria-hidden', String(!on));
        p.inert = !on;
      });
    }

    onBlockSelect = (e) => {
      const card = e.target.querySelector('[data-cat-card]');
      if (card) this.open(card);
    };

    onClick = (e) => {
      const card = e.target.closest('[data-cat-card]');
      if (card) {
        if (card.getAttribute('aria-expanded') !== 'true') this.open(card);
        return;
      }
      const add = e.target.closest('[data-cat-add]');
      if (add && !add.disabled) this.addToBag(add);
    };

    async addToBag(button) {
      const id = Number(button.dataset.variantId);
      if (!id) return;
      const label = button.textContent;
      button.disabled = true;
      try {
        // Same bag as the rest of the store (window.SolaraCart, via the main section's FurryMuse helper)
        if (!window.FurryMuse || typeof window.FurryMuse.addToCart !== 'function') throw new Error('bag unavailable');
        await window.FurryMuse.addToCart([window.FurryMuse.itemFrom(button)], 'Added to your bag.', button);
      } catch (err) {
        button.textContent = 'Try again';
        window.setTimeout(() => { button.textContent = label; }, 1800);
      } finally {
        button.disabled = false;
      }
    }
  }
  customElements.define('fm-categories', FmCategories);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fm-hero-slide"] && !Shopify.designMode) return;
  try {
    /* Hero button: smooth scroll to an on-page block instead of navigating away.
   One delegated listener for every slide. Without JS the plain #anchor link still jumps there. */
if (!window.__fmScrollToBound) {
  window.__fmScrollToBound = true;
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-fm-scroll-to]');
    if (!link) return;

    const id = link.dataset.fmScrollTo;
    // Fallback: if no block has this id yet, use the first product block on the page (Best Sellers is first)
    const target = document.getElementById(id) || (id === 'best-sellers' ? document.querySelector('[data-pa-products]') : null);
    if (!target) return; // nothing to scroll to: leave the link alone

    e.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

    // Keyboard / screen-reader users land in the section too (no extra scroll jump)
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fm-hero"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fm-hero')) {
  class FmHero extends HTMLElement {
    connectedCallback() {
      window.FurryMuse.ready(() => this.init());
    }

    init() {
      if (this.dataset.ready) return;
      this.slides = [...this.querySelectorAll('[data-pa-slide]')];
      this.active = 0;

      const multiple = this.slides.length > 1;
      this.querySelectorAll('[data-pa-hero-prev], [data-pa-hero-next]').forEach((b) => { b.hidden = !multiple; });

      this.querySelector('[data-pa-hero-prev]')?.addEventListener('click', () => { this.show(this.active - 1); this.start(); });
      this.querySelector('[data-pa-hero-next]')?.addEventListener('click', () => { this.show(this.active + 1); this.start(); });

      // Theme editor: jump to the slide being edited
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) { this.show(i); this.stop(); }
      });
      this.addEventListener('shopify:block:deselect', () => this.start());

      this.show(0, true);
      this.dataset.ready = 'true';
      this.start();
    }

    show(next, force) {
      if (this.slides.length < 2 && !force) return;
      this.active = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const selected = index === this.active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
      });
    }

    stop() { window.clearInterval(this.timer); }

    start() {
      this.stop();
      if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
        this.timer = window.setInterval(() => this.show(this.active + 1), Number(this.dataset.autoplaySpeed) || 6000);
      }
    }

    disconnectedCallback() { this.stop(); }
  }
  customElements.define('fm-hero', FmHero);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fm-muse-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fm-muse')) {
  class FmMuse extends HTMLElement {
    connectedCallback() {
      document.addEventListener('keydown', this.onKey);
      window.FurryMuse.ready(() => this.init());
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
    }

    init() {
      if (this.dataset.ready) return;
      this.slides = [...this.querySelectorAll('[data-ms-slide]')];
      this.cur = 0;
      const multiple = this.slides.length > 1;

      this.querySelectorAll('[data-ms-prev], [data-ms-next]').forEach((b) => { b.hidden = !multiple; });
      if (multiple) this.buildTabs();

      this.querySelector('[data-ms-prev]')?.addEventListener('click', () => this.go(this.cur - 1));
      this.querySelector('[data-ms-next]')?.addEventListener('click', () => this.go(this.cur + 1));

      // Hovering a dot highlights its chip (and the other way round)
      const hover = (e, on) => {
        const t = e.target.closest('[data-pi]');
        if (!t) return;
        t.closest('[data-ms-look]')?.querySelectorAll(`[data-pi="${t.dataset.pi}"]`).forEach((n) => n.classList.toggle('is-hover', on));
      };
      this.addEventListener('mouseover', (e) => hover(e, true));
      this.addEventListener('mouseout', (e) => hover(e, false));

      this.addEventListener('click', (e) => this.onClick(e));

      // Theme editor: jump to the slide being edited
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.indexOf(e.target);
        if (i > -1) this.go(i);
      });

      this.go(0);
      this.dataset.ready = 'true';
    }

    // Tabs are built here because a child block can't see its sibling slides in Liquid
    buildTabs() {
      this.slides.forEach((slide, si) => {
        const wrap = slide.querySelector('[data-ms-tabs]');
        if (!wrap) return;
        wrap.hidden = false;
        wrap.replaceChildren(...this.slides.map((s, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'ms-tab' + (i === si ? ' is-current' : '');
          b.dataset.msTab = String(i);
          b.setAttribute('role', 'tab');
          b.textContent = s.dataset.tabLabel || '';
          return b;
        }));
      });
    }

    // Un-mark the selected dot + chip (the photo and the card are handled separately)
    clearMarks(look) {
      look.querySelectorAll('[data-pi]').forEach((n) => {
        n.classList.remove('is-selected');
        n.setAttribute('aria-pressed', 'false');
      });
    }

    // Crossfade the pet photo. Two stacked layers (A/B): the new photo is loaded into the hidden layer
    // and faded in over the old one. Empty url = fade back to the main (no-jewelry) photo.
    showWorn(look, url) {
      const media = look.querySelector('[data-ms-media]');
      if (!media) return;
      const layers = [...media.querySelectorAll('[data-ms-layer]')];
      const token = (media.msToken = (media.msToken || 0) + 1);

      if (!url) {
        layers.forEach((l) => l.classList.remove('is-on'));
        media.classList.remove('is-worn');
        return;
      }

      const current = layers.find((l) => l.classList.contains('is-on'));
      const next = layers.find((l) => l !== current) || layers[0];
      const probe = new Image();
      const apply = () => {
        if (media.msToken !== token) return; // a newer click won
        next.src = url;
        layers.forEach((l) => l.classList.toggle('is-on', l === next));
        media.classList.add('is-worn');
      };
      probe.onload = apply;
      probe.onerror = apply;
      probe.src = url;
    }

    // Warm the browser cache so the first tap is instant
    preload() {
      const slide = this.slides[this.cur];
      if (!slide) return;
      this.preloaded = this.preloaded || new Set();
      const run = () => slide.querySelectorAll('[data-worn]').forEach((el) => {
        const u = el.dataset.worn;
        if (u && !this.preloaded.has(u)) { this.preloaded.add(u); new Image().src = u; }
      });
      if ('requestIdleCallback' in window) window.requestIdleCallback(run); else window.setTimeout(run, 300);
    }

    // Full close: back to the original photo and collapse the card
    closeLook(look) {
      if (!look) return;
      this.clearMarks(look);
      this.showWorn(look, '');
      const pop = look.querySelector('[data-ms-popover]');
      if (pop) { pop.classList.remove('is-active'); pop.setAttribute('aria-hidden', 'true'); }
    }

    go(n) {
      if (!this.slides.length) return;
      this.cur = (n + this.slides.length) % this.slides.length;
      this.querySelectorAll('[data-ms-look]').forEach((l) => this.closeLook(l));
      this.slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === this.cur);
        s.setAttribute('aria-hidden', String(i !== this.cur));
      });
      this.querySelectorAll('[data-ms-tab]').forEach((t) => {
        t.classList.toggle('is-current', Number(t.dataset.msTab) === this.cur);
      });
      this.preload();
    }

    onKey = (e) => {
      if (e.key === 'Escape') this.querySelectorAll('[data-ms-look]').forEach((l) => this.closeLook(l));
    };

    onClick(e) {
      const tab = e.target.closest('[data-ms-tab]');
      if (tab) { this.go(Number(tab.dataset.msTab)); return; }

      const closeBtn = e.target.closest('[data-ms-close]');
      if (closeBtn) { this.closeLook(closeBtn.closest('[data-ms-look]')); return; }

      const addAll = e.target.closest('[data-ms-add-all]');
      if (addAll) {
        // every available product of this look (each dot carries its own bag data)
        const seen = new Set();
        const items = [...(addAll.closest('[data-ms-look]')?.querySelectorAll('[data-ms-hotspot][data-variant-id]') || [])]
          .filter((dot) => dot.dataset.variantId && !seen.has(dot.dataset.variantId) && seen.add(dot.dataset.variantId))
          .map((dot) => window.FurryMuse.itemFrom(dot));
        if (items.length && !addAll.disabled) window.FurryMuse.addToCart(items, 'The full look was added to your bag.', addAll);
        return;
      }

      const add = e.target.closest('[data-ms-add]');
      if (add) {
        const variantId = Number(add.dataset.variantId);
        if (variantId && !add.disabled) window.FurryMuse.addToCart([window.FurryMuse.itemFrom(add)], 'Added to your bag.', add);
        return;
      }

      // Dot or chip
      const item = e.target.closest('[data-pi]');
      if (!item) return;
      const look = item.closest('[data-ms-look]');
      const pi = item.dataset.pi;

      if (item.classList.contains('is-selected')) { this.closeLook(look); return; }

      this.clearMarks(look);
      look.querySelectorAll(`[data-pi="${pi}"]`).forEach((n) => {
        n.classList.add('is-selected');
        n.setAttribute('aria-pressed', 'true');
      });
      // the clicked button carries its OWN photo (no index lookup)
      this.showWorn(look, item.dataset.worn || '');

      const pop = look.querySelector('[data-ms-popover]');
      if (!pop) return;
      const img = pop.querySelector('[data-ms-pop-img]');
      pop.querySelector('[data-ms-pop-title]').textContent = item.dataset.title || '';
      pop.querySelector('[data-ms-pop-price]').textContent = item.dataset.price || '';
      pop.querySelector('[data-ms-pop-link]').href = item.dataset.url || '#';
      if (img) { img.src = item.dataset.image || ''; img.style.visibility = item.dataset.image ? 'visible' : 'hidden'; }
      const addBtn = pop.querySelector('[data-ms-add]');
      // the popover's button carries the selected product's bag data
      ['variantId', 'title', 'variantTitle', 'priceCents', 'image', 'url', 'category'].forEach((key) => { addBtn.dataset[key] = item.dataset[key] || ''; });
      addBtn.disabled = !item.dataset.variantId;
      addBtn.textContent = item.dataset.variantId ? 'Add to bag' : 'Unavailable';
      pop.classList.add('is-active');
      pop.setAttribute('aria-hidden', 'false');
    }

  }

  customElements.define('fm-muse', FmMuse);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fm-product-carousel"] && !Shopify.designMode) return;
  try {
    /* Quick-add (+) button on any product card. One delegated listener, works after theme-editor re-renders. */
if (!window.__fmQuickAddBound) {
  window.__fmQuickAddBound = true;
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-pa-quick-add]');
    if (!button) return;
    const variantId = Number(button.dataset.variantId);
    if (!variantId || button.disabled) return;
    window.FurryMuse?.addToCart([window.FurryMuse.itemFrom(button)], 'Added to your bag.', button);
  });
}

/* "View all": reveals the next batch of hidden cards (step 2, then step 3).
   When nothing is hidden any more the click is not intercepted, so the link goes to the collection. */
if (!window.__fmShowMoreBound) {
  window.__fmShowMoreBound = true;
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-pa-more]');
    if (!button) return;
    const root = button.closest('[data-pa-products]');
    const hidden = root ? [...root.querySelectorAll('[data-pa-product-card][hidden]')] : [];
    if (!hidden.length) return; // nothing left to reveal: normal navigation to the collection

    e.preventDefault();
    const step = Math.min(...hidden.map((card) => Number(card.dataset.paStep)));
    const batch = hidden.filter((card) => Number(card.dataset.paStep) === step);

    batch.forEach((card, i) => {
      card.style.setProperty('--pa-i', Math.min(i, 7));
      card.hidden = false;
      card.classList.add('is-revealing');
      card.addEventListener('animationend', () => card.classList.remove('is-revealing'), { once: true });
    });
    batch[0].querySelector('a')?.focus({ preventScroll: true });

    // Last batch shown and the collection has no extra products beyond this block's limit: the button is no longer needed
    const nothingLeft = hidden.length === batch.length;
    if (nothingLeft && button.dataset.hasMore !== 'true') {
      button.closest('.pa-products-more-wrap')?.remove();
    }
  });
}

/* Carousel layout: arrows scroll one "page" of cards; arrows hide when everything already fits */
if (!customElements.get('fm-products')) {
  class FmProducts extends HTMLElement {
    connectedCallback() {
      window.FurryMuse.ready(() => this.init());
    }

    init() {
      if (this.dataset.ready) return;
      this.track = this.querySelector('[data-pa-track]');
      this.prev = this.querySelector('[data-pa-prev]');
      this.next = this.querySelector('[data-pa-next]');
      if (!this.track || !this.prev || !this.next) return; // grid layout: nothing to do

      this.prev.addEventListener('click', () => this.step(-1));
      this.next.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
      this.dataset.ready = 'true';
    }

    disconnectedCallback() { this.resizeObserver?.disconnect(); }

    step(direction) {
      const card = this.track.querySelector('[data-pa-product-card]');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const cardWidth = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      const perPage = Math.max(1, Math.floor(this.track.clientWidth / cardWidth));
      this.track.scrollBy({ left: direction * cardWidth * perPage, behavior: 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const scrollable = max > 4;
      this.prev.hidden = !scrollable;
      this.next.hidden = !scrollable;
      this.prev.disabled = this.track.scrollLeft <= 4;
      this.next.disabled = this.track.scrollLeft >= max - 4;
    }
  }
  customElements.define('fm-products', FmProducts);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fm-ticker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fm-ticker')) {
  class FmTicker extends HTMLElement {
    connectedCallback() {
      window.FurryMuse.ready(() => {
        this.source = this.querySelector('[data-pa-ticker-source]');
        if (!this.source) return;
        this.build();

        // Rebuild when the width changes or web fonts finish loading
        let frame;
        const rebuild = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(() => this.build()); };
        this.resizeObserver = new ResizeObserver(rebuild);
        this.resizeObserver.observe(this.parentElement);
        document.fonts?.ready.then(rebuild);
      });
    }

    disconnectedCallback() { this.resizeObserver?.disconnect(); }

    build() {
      // remove old copies, keep only the real group
      this.querySelectorAll('[data-pa-ticker-copy]').forEach((n) => n.remove());

      const groupWidth = this.source.offsetWidth;
      const viewWidth = this.parentElement.clientWidth;
      if (!groupWidth || !viewWidth) return;

      // total groups: enough to cover 2x the screen, and EVEN (the loop shifts by exactly half)
      let total = Math.max(2, Math.ceil((viewWidth * 2) / groupWidth));
      if (total % 2) total += 1;

      for (let i = 1; i < total; i += 1) {
        const copy = this.source.cloneNode(true);
        copy.removeAttribute('data-pa-ticker-source');
        copy.setAttribute('data-pa-ticker-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
        this.appendChild(copy);
      }

      // constant speed (~32px per second) no matter how many phrases there are
      const pxPerSecond = 32;
      this.style.setProperty('--pa-ticker-duration', `${((groupWidth * total) / 2 / pxPerSecond).toFixed(1)}s`);
    }
  }
  customElements.define('fm-ticker', FmTicker);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pd-buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-buy-box')) {
    const pdMoney = (cents, format) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, format);
      const num = (c, decimals, thousands, decimal) => {
        const parts = (c / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return parts.join(decimal);
      };
      return String(format || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, key) => {
        switch (key) {
          case 'amount_no_decimals': return num(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
          default: return num(cents, 2, ',', '.');
        }
      });
    };

    class PdBuyBox extends HTMLElement {
      /* Keeps the box just under the header while the gallery/details column scrolls, and stops it at the
         bottom of that column (right before the fit guide). Pure geometry + transform: no dependence on
         position: sticky, so ancestors' overflow can't break it. Desktop/tablet only (>= 750px). */
      follow() {
        const cell = this.closest('.pd-cell--buy');
        const top = this.closest('.pd-top');
        if (!cell || !top) return;
        const header = (this.closest('.pd-main') || document).querySelector('pd-header');
        const desktop = window.matchMedia('(min-width: 750px)');
        const GAP = 24;
        let applied = 0;

        const update = () => {
          if (!desktop.matches) {
            this.removeAttribute('data-follow');
            this.style.transform = '';
            applied = 0;
            return;
          }
          this.setAttribute('data-follow', '');
          const natural = cell.getBoundingClientRect().top;                      // where the box sits with no offset
          const anchor = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + GAP;
          const padBottom = parseFloat(getComputedStyle(top).paddingBottom) || 0;
          const limit = top.getBoundingClientRect().bottom - padBottom - this.offsetHeight; // lowest allowed top
          const wanted = Math.max(natural, Math.min(Math.max(natural, anchor), limit));
          const y = Math.round(wanted - natural);
          if (y !== applied) {
            this.style.transform = y ? 'translate3d(0,' + y + 'px,0)' : '';
            applied = y;
          }
        };

        document.addEventListener('scroll', update, { passive: true, capture: true }); // capture: also catches scrolling wrappers
        window.addEventListener('resize', update);
        window.addEventListener('load', update);
        let ro = null;
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(update);
          [this, cell, top, header].forEach((node) => { if (node) ro.observe(node); });
        }
        this._unfollow = () => {
          document.removeEventListener('scroll', update, { capture: true });
          window.removeEventListener('resize', update);
          window.removeEventListener('load', update);
          if (ro) ro.disconnect();
        };
        update();
      }

      connectedCallback() {
        this.follow();
        const read = (selector) => {
          try { return JSON.parse(this.querySelector(selector).textContent); } catch (error) { return null; }
        };
        this.variants = read('[data-pdb-variants]') || [];
        this.stock = read('[data-pdb-stock]') || {};
        this.cfg = read('[data-pdb-config]') || { text: {} };
        this.text = this.cfg.text || {};
        this.form = this.querySelector('[data-pdb-form]');
        if (!this.form) return;

        this.idInput = this.form.querySelector('[data-pdb-id]');
        this.radios = Array.prototype.slice.call(this.querySelectorAll('[data-pdb-option]'));
        this.qty = this.querySelector('[data-pdb-qty]');
        this.submit = this.querySelector('[data-pdb-submit]');
        this.barSubmit = this.querySelector('[data-pdb-bar-submit]');
        this.bar = this.querySelector('[data-pdb-bar]');
        this.message = this.querySelector('[data-pdb-message]');
        this.busy = false;
        this.current = this.variants.find((v) => String(v.id) === String(this.idInput.value)) || this.variants[0] || null;

        this.radios.forEach((radio) => radio.addEventListener('change', () => this.pick()));
        this.querySelector('[data-pdb-minus]').addEventListener('click', () => this.setQty(Number(this.qty.value) - this.rules().step));
        this.querySelector('[data-pdb-plus]').addEventListener('click', () => this.setQty(Number(this.qty.value) + this.rules().step));
        this.qty.addEventListener('change', () => this.setQty(this.qty.value));
        this.form.addEventListener('submit', (event) => { event.preventDefault(); this.add(); });
        if (this.barSubmit) this.barSubmit.addEventListener('click', () => this.add());

        this.render(false);
        this.watchBar();
      }

      disconnectedCallback() {
        if (this._unfollow) this._unfollow();
        if (this.io) this.io.disconnect();
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      }

      selected() {
        const options = [];
        this.radios.forEach((radio) => { if (radio.checked) options[Number(radio.dataset.optionIndex)] = radio.value; });
        return options;
      }

      pick() {
        const options = this.selected();
        this.current = this.variants.find((v) => v.options.every((value, i) => value === options[i])) || null;
        this.render(true);
      }

      rules() {
        const v = this.current || {};
        const r = v.quantity_rule || {};
        const s = this.stock[v.id] || {};
        let max = Number(r.max) || 0;
        if (s.m && s.p !== 'continue' && s.q > 0) max = max ? Math.min(max, s.q) : s.q;
        return { min: Number(r.min) || 1, step: Number(r.increment) || 1, max: max };
      }

      setQty(raw) {
        const rule = this.rules();
        let value = Number(raw);
        if (!isFinite(value)) value = rule.min;
        value = Math.max(rule.min, rule.min + Math.round((value - rule.min) / rule.step) * rule.step);
        if (rule.max > 0) value = Math.min(rule.max, value);
        this.qty.value = String(value);
      }

      stockInfo(v) {
        const t = this.text;
        if (!v) return { state: 'out', label: t.unavailable };
        if (!v.available) return { state: 'out', label: t.outOfStock };
        const s = this.stock[v.id];
        if (s && s.m && s.p !== 'continue' && s.q > 0) {
          if (this.cfg.mode === 'count') return { state: 'ok', label: String(t.count || '').replace('[count]', s.q) };
          if (this.cfg.mode === 'low' && s.q <= Number(this.cfg.threshold)) return { state: 'low', label: String(t.low || '').replace('[count]', s.q) };
        }
        return { state: 'ok', label: t.inStock };
      }

      render(push) {
        const v = this.current;
        const t = this.text;
        this.idInput.value = v ? v.id : '';

        const price = v ? pdMoney(v.price, this.cfg.money) : '';
        this.querySelector('[data-pdb-price]').textContent = price;
        const barPrice = this.querySelector('[data-pdb-bar-price]');
        if (barPrice) barPrice.textContent = price;

        const compare = this.querySelector('[data-pdb-compare]');
        const onSale = v && Number(v.compare_at_price) > Number(v.price);
        compare.classList.toggle('is-hidden', !onSale);
        compare.textContent = onSale ? pdMoney(v.compare_at_price, this.cfg.money) : '';

        const info = this.stockInfo(v);
        const line = this.querySelector('[data-pdb-stock-line]');
        line.dataset.state = info.state;
        this.querySelector('[data-pdb-stock-label]').textContent = info.label;

        const label = !v ? t.unavailable : (v.available ? t.add : t.soldOut);
        const disabled = !v || !v.available;
        this.submit.disabled = disabled;
        this.querySelector('[data-pdb-submit-label]').textContent = label;
        if (this.barSubmit) {
          this.barSubmit.disabled = disabled;
          this.querySelector('[data-pdb-bar-label]').textContent = label;
        }
        const notify = this.querySelector('[data-pdb-notify]');
        if (notify) notify.classList.toggle('is-hidden', Boolean(v && v.available));

        // Disable option values that have no available variant with the other current choices.
        const options = this.selected();
        this.radios.forEach((radio) => {
          const index = Number(radio.dataset.optionIndex);
          const candidate = options.slice();
          candidate[index] = radio.value;
          radio.disabled = !this.variants.some((variant) =>
            variant.available && variant.options.every((value, i) => i === index || value === candidate[i]));
        });

        const rule = this.rules();
        this.qty.min = String(rule.min);
        this.qty.step = String(rule.step);
        if (rule.max) this.qty.max = String(rule.max); else this.qty.removeAttribute('max');
        this.setQty(this.qty.value);

        if (push && v) {
          const mediaId = v.featured_media ? v.featured_media.id : null;
          document.dispatchEvent(new CustomEvent('pd:variant-change', { detail: { variant: v, mediaId: mediaId } }));
          if (window.history && window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
        }
      }

      async add() {
        if (this.busy || !this.current || !this.current.available) return;
        this.busy = true;
        this.submit.setAttribute('aria-busy', 'true');
        this.submit.disabled = true;
        this.message.textContent = '';
        try {
          // Goes into the store's ONE custom bag (window.SolaraCart, see snippets/furry-cart.liquid),
          // not Shopify's /cart, so pet and human products are in the same bag. The header badge updates itself.
          if (!window.SolaraCart) throw new Error('The bag is not available. Please refresh the page.');
          const v = this.current;
          const product = this.cfg.product || {};
          window.SolaraCart.add({
            id: v.id,
            quantity: Number(this.qty.value) || 1,
            title: product.title,
            variantTitle: v.public_title || '',
            priceCents: v.price,
            image: (v.featured_image && v.featured_image.src) || product.image,
            url: product.url,
            category: product.type || undefined
          });
          this.message.textContent = this.text.added || '';
        } catch (error) {
          this.message.textContent = error instanceof Error ? error.message : 'Unable to add this item.';
        } finally {
          this.busy = false;
          this.submit.removeAttribute('aria-busy');
          this.render(false);
        }
      }

      watchBar() {
        if (!this.bar || !this.submit || !('IntersectionObserver' in window)) return;
        let buttonVisible = true;
        const apply = () => {
          const show = !buttonVisible && window.scrollY > 120;
          this.bar.classList.toggle('is-visible', show);
          this.bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          if (this.barSubmit) this.barSubmit.tabIndex = show ? 0 : -1;
        };
        this.io = new IntersectionObserver((entries) => { buttonVisible = entries[0].isIntersecting; apply(); });
        this.io.observe(this.submit);
        this._onScroll = apply;
        window.addEventListener('scroll', this._onScroll, { passive: true });
      }
    }
    customElements.define('pd-buy-box', PdBuyBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pd-fit-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-fit-guide')) {
    class PdFitGuide extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-pdf-input]');
        this.result = this.querySelector('[data-pdf-result]');
        this.message = this.querySelector('[data-pdf-message]');
        this.units = Array.prototype.slice.call(this.querySelectorAll('[data-pdf-unit]'));
        if (!this.input) return;
        this.lastUnit = this.unit();
        this.applyLimit();
        this.input.addEventListener('input', () => { this.applyLimit(); this.calc(); });
        this.input.addEventListener('change', () => { this.applyLimit(); this.calc(); });
        this.units.forEach((unit) => unit.addEventListener('change', () => this.onUnitChange()));
      }

      unit() {
        const checked = this.units.find((unit) => unit.checked);
        return checked ? checked.value : 'cm';
      }

      // Hard input limit: 48 cm / 18.9 in
      limit(unit) {
        return (unit || this.unit()) === 'in' ? 18.9 : 48;
      }

      // Stops the field (typing and the arrows) at the limit
      applyLimit() {
        const limit = this.limit();
        this.input.max = String(limit);
        const value = parseFloat(String(this.input.value).replace(',', '.'));
        if (value > limit) this.input.value = String(limit);
      }

      // Converts the typed number when switching cm <-> in, then keeps it within the limit
      onUnitChange() {
        const now = this.unit();
        const value = parseFloat(String(this.input.value).replace(',', '.'));
        if (value > 0 && this.lastUnit && this.lastUnit !== now) {
          const converted = now === 'in' ? value / 2.54 : value * 2.54;
          this.input.value = String(Math.round(converted * 10) / 10);
        }
        this.lastUnit = now;
        this.applyLimit();
        this.calc();
      }

      fmt(cm) {
        const inches = cm / 2.54;
        return (Math.round(cm * 10) / 10) + ' cm / ' + (Math.round(inches * 10) / 10) + ' in';
      }

      show(state, text) {
        this.result.dataset.state = state;
        this.message.textContent = text;
      }

      calc() {
        const d = this.dataset;
        let neck = parseFloat(String(this.input.value).replace(',', '.'));
        if (!(neck > 0)) { this.show('idle', d.msgIdle || ''); return; }
        if (this.unit() === 'in') neck = neck * 2.54;

        const allowance = Number(d.allowance) || 0;
        const min = Number(d.min) || 0;
        const MAX_CAP = 48; // hard limit: 48 cm (≈ 18.9 in)
        const max = Math.min(Number(d.max) || MAX_CAP, MAX_CAP);
        const needed = neck + allowance;
        const fill = (template) => String(template || '')
          .replace('[neck]', this.fmt(neck))
          .replace('[size]', this.fmt(needed))
          .replace('[min]', this.fmt(min))
          .replace('[max]', this.fmt(max));

        if (min && needed < min) this.show('small', fill(d.msgSmall));
        else if (max && needed > max) this.show('large', fill(d.msgLarge));
        else this.show('ok', fill(d.msgOk));
      }
    }
    customElements.define('pd-fit-guide', PdFitGuide);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pd-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-gallery')) {
    class PdGallery extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('[data-pdg-modal]');
        if (!this.modal) return;

        this.track = this.modal.querySelector('[data-pdg-track]');
        this.slides = Array.prototype.slice.call(this.modal.querySelectorAll('[data-pdg-slide]'));
        this.thumbs = Array.prototype.slice.call(this.modal.querySelectorAll('[data-pdg-thumb]'));
        this.counter = this.modal.querySelector('[data-pdg-counter]');
        this.mainButton = this.querySelector('.pdg-card--main');
        this.index = 0;
        this.active = 0;
        this.opener = null;
        this.isOpen = false;

        this._onKey = this.onKey.bind(this);
        this._onVariant = this.onVariant.bind(this);

        this.querySelectorAll('[data-pdg-open]').forEach((button) => {
          button.addEventListener('click', () => {
            const isMain = button.classList.contains('pdg-card--main');
            this.open(isMain ? this.active : Number(button.dataset.pdgOpen || 0), button);
          });
        });

        this.modal.querySelectorAll('[data-pdg-close]').forEach((node) => node.addEventListener('click', () => this.close()));
        const prev = this.modal.querySelector('[data-pdg-prev]');
        const next = this.modal.querySelector('[data-pdg-next]');
        if (prev) prev.addEventListener('click', () => this.step(-1));
        if (next) next.addEventListener('click', () => this.step(1));
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.pdgThumb), true)));

        let timer = 0;
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => {
            const width = this.track.clientWidth || 1;
            this.setIndex(Math.round(this.track.scrollLeft / width));
          }, 70);
        }, { passive: true });

        document.addEventListener('pd:variant-change', this._onVariant);
      }

      disconnectedCallback() {
        document.removeEventListener('pd:variant-change', this._onVariant);
        document.removeEventListener('keydown', this._onKey);
        document.documentElement.classList.remove('pdg-lock');
        if (this.modal && this.modal.parentNode === document.body) this.modal.remove();
      }

      open(index, opener) {
        if (this.isOpen) return;
        this.isOpen = true;
        this.opener = opener || document.activeElement;
        document.body.appendChild(this.modal);
        this.modal.hidden = false;
        document.documentElement.classList.add('pdg-lock');
        document.addEventListener('keydown', this._onKey);
        window.requestAnimationFrame(() => {
          this.modal.classList.add('is-open');
          this.goTo(index || 0, false);
          const closeButton = this.modal.querySelector('[data-pdg-first]');
          if (closeButton) closeButton.focus({ preventScroll: true });
        });
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.modal.classList.remove('is-open');
        document.removeEventListener('keydown', this._onKey);
        this.modal.querySelectorAll('video').forEach((video) => video.pause());
        window.setTimeout(() => {
          if (this.isOpen) return;
          this.modal.hidden = true;
          this.appendChild(this.modal);
          document.documentElement.classList.remove('pdg-lock');
          if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
        }, 260);
      }

      step(direction) {
        const count = this.slides.length;
        if (!count) return;
        this.goTo((this.index + direction + count) % count, true);
      }

      goTo(index, smooth) {
        const count = this.slides.length;
        if (!count) return;
        const target = Math.max(0, Math.min(count - 1, index));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
        this.setIndex(target);
      }

      setIndex(index) {
        if (index === this.index && this.counter && this.counter.textContent) {
          if (this.thumbs[index] && this.thumbs[index].classList.contains('is-active')) return;
        }
        this.index = index;
        if (this.counter) this.counter.textContent = (index + 1) + ' / ' + this.slides.length;
        this.thumbs.forEach((thumb, i) => {
          const on = i === index;
          thumb.classList.toggle('is-active', on);
          if (on) {
            thumb.setAttribute('aria-current', 'true');
            thumb.scrollIntoView({ block: 'nearest', inline: 'center' });
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }

      onKey(event) {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); return; }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); return; }
        if (event.key === 'Tab') {
          const focusable = Array.prototype.slice.call(this.modal.querySelectorAll('button, [href], video[controls], [tabindex]:not([tabindex="-1"])'))
            .filter((node) => !node.disabled && node.offsetParent !== null);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }

      /* When the buyer picks a variant that has its own photo, show it on the main card. */
      onVariant(event) {
        const mediaId = event && event.detail ? event.detail.mediaId : null;
        if (!mediaId || !this.mainButton) return;
        const index = this.slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (index < 0) return;
        const source = this.slides[index].querySelector('img');
        const target = this.mainButton.querySelector('img');
        if (!source || !target) return;
        this.active = index;
        target.src = source.getAttribute('src');
        const srcset = source.getAttribute('srcset');
        if (srcset) target.setAttribute('srcset', srcset);
        target.alt = source.alt;
      }
    }
    customElements.define('pd-gallery', PdGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pd-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pd-reviews')) {
    class PdReviews extends HTMLElement {
      connectedCallback() {
        const d = this.dataset;
        this.endpoint = d.endpoint || '';
        this.dialog = this.querySelector('[data-pdr-dialog]');
        this.form = this.querySelector('[data-pdr-form]');
        this.lightbox = this.querySelector('[data-pdr-lightbox]');
        this.list = this.querySelector('[data-pdr-list]');
        this.file = null;

        // "Show all" — long lists start collapsed
        const hasExtra = this.list && this.list.querySelector('.is-extra');
        if (hasExtra) this.list.classList.add('is-collapsed');
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-pdr-more]')) {
            this.list.classList.remove('is-collapsed');
            e.target.closest('[data-pdr-more]').remove();
          }
          if (e.target.closest('[data-pdr-open]') && this.dialog) this.open();
          if (e.target.closest('[data-pdr-close]') && this.dialog) this.dialog.close();
          const photo = e.target.closest('[data-pdr-photo]');
          if (photo && this.lightbox) {
            this.lightbox.querySelector('[data-pdr-lightbox-img]').src = photo.dataset.full;
            this.lightbox.showModal();
          }
          if (e.target.closest('[data-pdr-lightbox-close]') && this.lightbox) this.lightbox.close();
          if (e.target === this.lightbox) this.lightbox.close();
          if (e.target === this.dialog) this.dialog.close();
        });

        if (!this.form) return;
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
        const input = this.form.querySelector('[data-pdr-file]');
        const drop = this.form.querySelector('[data-pdr-drop]');
        input.addEventListener('change', () => this.pick(input.files && input.files[0]));
        ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
        ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
        drop.addEventListener('drop', (e) => this.pick(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]));
        this.form.querySelector('[data-pdr-remove]').addEventListener('click', () => this.pick(null));
      }

      open() {
        this.dialog.classList.remove('is-done');
        this.setStatus('');
        this.dialog.showModal();
      }

      setStatus(text, ok) {
        const el = this.form && this.form.querySelector('[data-pdr-status]');
        if (!el) return;
        el.textContent = text;
        el.classList.toggle('is-ok', Boolean(ok));
      }

      // Shrink big phone photos in the browser before upload (max 1600px, JPEG)
      async shrink(file) {
        try {
          const url = URL.createObjectURL(file);
          const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = url; });
          const scale = Math.min(1, 1600 / Math.max(img.naturalWidth, img.naturalHeight));
          const canvas = document.createElement('canvas');
          canvas.width = Math.round(img.naturalWidth * scale);
          canvas.height = Math.round(img.naturalHeight * scale);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(url);
          const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.86));
          return blob || file;
        } catch (error) {
          return file; // e.g. a format the browser can't draw: send as is, the server checks it
        }
      }

      async pick(file) {
        const preview = this.form.querySelector('[data-pdr-preview]');
        const drop = this.form.querySelector('[data-pdr-drop]');
        const remove = this.form.querySelector('[data-pdr-remove]');
        const input = this.form.querySelector('[data-pdr-file]');
        if (!file) {
          this.file = null; input.value = ''; preview.hidden = true; preview.removeAttribute('src');
          drop.classList.remove('has-image'); remove.hidden = true;
          return;
        }
        if (!/^image\//.test(file.type)) { this.setStatus('Please choose an image file.'); return; }
        this.setStatus('');
        this.file = await this.shrink(file);
        if (this.file.size > 6 * 1024 * 1024) { this.file = null; this.setStatus('This photo is too large. Please choose a smaller one.'); return; }
        preview.src = URL.createObjectURL(this.file);
        preview.hidden = false;
        drop.classList.add('has-image');
        remove.hidden = false;
      }

      async submit() {
        const f = this.form;
        const val = (n) => (f.elements[n] ? f.elements[n].value.trim() : '');
        const rating = (f.querySelector('input[name="rating"]:checked') || {}).value;
        f.querySelectorAll('.has-error').forEach((n) => n.classList.remove('has-error'));
        const bad = [];
        if (!rating) bad.push(f.querySelector('.pdr-rate').closest('.pdr-field'));
        if (!val('author')) bad.push(f.elements.author.closest('.pdr-field'));
        if (val('body').length < 10) bad.push(f.elements.body.closest('.pdr-field'));
        const email = val('email');
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) bad.push(f.elements.email.closest('.pdr-field'));
        if (bad.length) {
          bad.forEach((n) => n.classList.add('has-error'));
          this.setStatus(!rating ? 'Please choose a star rating.' : 'Please fill in the highlighted fields.');
          return;
        }

        const btn = f.querySelector('[data-pdr-submit]');
        btn.disabled = true;
        this.setStatus('Sending…');
        const body = new FormData();
        body.set('product_id', this.dataset.productId);
        body.set('product_title', this.dataset.productTitle);
        body.set('rating', rating);
        body.set('author', val('author'));
        body.set('email', email);
        body.set('body', val('body'));
        body.set('website', val('website')); // honeypot
        body.set('loaded_at', this.dataset.loadedAt);
        if (this.file) body.set('photo', this.file, 'photo.jpg');

        try {
          const res = await fetch(this.endpoint, { method: 'POST', body });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.error) throw new Error(data.error || '');
          this.dialog.classList.add('is-done');
          this.setStatus(this.dataset.success, true);
          f.reset();
          this.pick(null);
        } catch (error) {
          this.setStatus(error && error.message ? error.message : this.dataset.error);
        } finally {
          btn.disabled = false;
        }
      }
    }
    customElements.define('pd-reviews', PdReviews);
  }
  } catch(e) { console.error(e); }
})();

})();
